module.exports = __webpack_public_path__ + "img/404.70346015.png";